var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave-status-cell"},[(_vm.wave.status === 'published')?_c('Pill',{attrs:{"color":"green","large":""}},[_vm._v("Published")]):(_vm.wave.status === 'draft')?_c('Pill',{attrs:{"color":"blue","large":""}},[_vm._v("Draft")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }